/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section4_TitleInputs */

const en_terms_section4_title = /** @type {(inputs: Terms_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disclaimer of Warranties`)
};

const ko_terms_section4_title = /** @type {(inputs: Terms_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보증 면책`)
};

const ja_terms_section4_title = /** @type {(inputs: Terms_Section4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保証の免責`)
};

/**
* | output |
* | --- |
* | "Disclaimer of Warranties" |
*
* @param {Terms_Section4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section4_title = /** @type {((inputs?: Terms_Section4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section4_title(inputs)
	if (locale === "ko") return ko_terms_section4_title(inputs)
	return ja_terms_section4_title(inputs)
});